import axios from "../plugins/parseAxios";
export class ContractLogAPI {
  constructor(props) { }
  static getContractLog(payload) {
    return axios.post("functions/getContractLog", {
      id: payload.id
    });
  }
  static getContractLogByContracts(payload) {
    return axios.post("functions/getContractLogByContracts", payload);
  }

}
